import translationEN from './en.json'
import translationES from './es.json'
import translationPT from './pt.json'
import translationDE from './de.json'
import translationFR from './fr.json'
import translationIT from './it.json'
import translationNL from './nl.json'
import translationPL from './pl.json'
import translationRU from './ru.json'
import translationSV from './sv.json'
import translationTR from './tr.json'
import translationJA from './ja.json'
import translationKO from './ko.json'
import translationZHCN from './zh-CN.json'
import translationZHTW from './zh-TW.json'
import translationTH from './th.json'
import translationVI from './vi.json'
import translationID from './id.json'
import translationMS from './ms.json'
import translationFIL from './fil.json'
import translationAR from './ar.json'
import translationHI from './hi.json'
import translationBN from './bn.json'
import translationML from './ml.json'
import translationUR from './ur.json'
import translationMN from './mn.json'

export const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  pt: { translation: translationPT },
  de: { translation: translationDE },
  fr: { translation: translationFR },
  it: { translation: translationIT },
  nl: { translation: translationNL },
  pl: { translation: translationPL },
  ru: { translation: translationRU },
  sv: { translation: translationSV },
  tr: { translation: translationTR },
  ja: { translation: translationJA },
  ko: { translation: translationKO },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'zh-CN': { translation: translationZHCN },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'zh-TW': { translation: translationZHTW },
  th: { translation: translationTH },
  vi: { translation: translationVI },
  id: { translation: translationID },
  ms: { translation: translationMS },
  fil: { translation: translationFIL },
  ar: { translation: translationAR },
  hi: { translation: translationHI },
  bn: { translation: translationBN },
  ml: { translation: translationML },
  ur: { translation: translationUR },
  mn: { translation: translationMN },
}
